export default __webpack_public_path__ + "static/about-us-f27b73e6e2564d5f3301112e60fec4e4.jpg";